import { render, staticRenderFns } from "./SSCustomerMail.vue?vue&type=template&id=72abfaa4&"
import script from "./SSCustomerMail.vue?vue&type=script&lang=js&"
export * from "./SSCustomerMail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports